export class JobSort {
    constructor(
        public empty: boolean = false,
        public sorted: boolean = false,
        public unsorted: boolean = false
    ){}
}